import { createContext, useContext } from "react";
import type { TabId } from "./schema";

/**
 * What a row needs to know about the section it sits in — supplied once by
 * InspectorSection so that ~300 rows do not each subscribe to the `ui` slice
 * (every keystroke in the search box used to re-render every mounted row).
 */
export interface SectionInfo {
  tabId: TabId;
  sectionId: string;
  /** The section's shown title, for Undo labels ("Glow (bloom) · Intensity"). */
  title: string;
  /** Search terms to mark in labels. */
  mark?: string[];
  pins: ReadonlySet<string>;
  /** Rows flagged "duplicate" (a second control over one value) show only then. */
  showExperimental: boolean;
  togglePin: (path: string) => void;
}

export const SectionCtx = createContext<SectionInfo | null>(null);

export function useSectionInfo(): SectionInfo | null {
  return useContext(SectionCtx);
}
